import React,{useEffect,useState} from 'react';
import Logo from '../../components/common/Logo';
import ForgotPasswordForm from '../../components/Auth/ForgotPasswordForm';
import {useNavigate} from 'react-router-dom';
import swal from 'sweetalert';
import {ForgotPassword} from '../../actions/AmbassadorActions';
import moment from 'moment';

function AmbassadorForgotPassword(){
    const navigate = useNavigate();
    const [loading,setLoading] = useState(false)

    const date = moment().format('YYYY-MM-DD')
    const nextYear = moment(date).add(1, 'years').format('YYYY')


    useEffect(() => {
        if(sessionStorage.getItem('ambDetail')){
            navigate('/ambassador/dashboard');
        }
    },[]);
    const onSubmit=(model)=>{
        setLoading(true)
        ForgotPassword(model).then(res => {
            if (res.status) {

                swal(res.message,'','success');
                setLoading(false)
                
            }
            else{
                swal(res.message,'','error');
                setLoading(false)
            }
        })
        .catch(err => {
            console.log(err);
        })
    }
    return(
       <>
       <section className="py-5 login-page">
        <div className="container">
            <div className="row justify-content-center">
                <div className="col-lg-6">
                        <div className="both_logo_wrapper">
                            <a href='https://www.allenoverseas.com' target="_blank" title="ALLEN Overseas - Coaching Classes for JEE, NEET & Foundation">
                                <Logo alt="Logo" className="mb-4"/>
                            </a>
                        </div>
                    <div className="login-box">
                        <div className="page-head">
                            <h2>Forgot Password</h2>
                        </div>
                        <ForgotPasswordForm onSubmit={onSubmit} loading={loading}/>
                    </div>
                </div>
            </div>
        </div>
    </section>
       </>
    );
}

export default AmbassadorForgotPassword;



